import { Injectable } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { QuestionBase } from '@app/core/models/question/question-base';
import { TextboxQuestion } from '@app/core/models/question/textbox-question';

@Injectable()
export class QuestionControlService {
  toFormGroup(questions: QuestionBase<any>[]) {
    const group: any = {};
    questions.forEach(question => {
      const validators = [];
      if (question.required) {
        validators.push(Validators.required);
      }

      if (question instanceof TextboxQuestion) {
        switch (question.type) {
          case 'email':
            validators.push(Validators.email);
            break;
          case 'number':
            validators.push(Validators.pattern('^[0-9]*[0-9,.]*[0-9]$'));
            break;
          case 'date':
            break;
          case 'password':
            break;
        }
      }

      group[question.key] = new FormControl(question.value || '', validators);
    });

    return new FormGroup(group);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/question-control.service.ts